<script lang="ts">
    import { modalManagerToken } from "@/tokens";
    import Page from "@apps/iloom_customization/components/Page.svelte";
    import PageTitle from "@apps/iloom_customization/components/PageTitle.svelte";
    import DesignFeedModal from "@apps/iloom_customization/design_feed/components/DesignFeedModal/DesignFeedModal.svelte";
    import { MediaListQuery } from "@apps/iloom_customization/design_feed/queries/MediaListQuery";
    import { DesignFeedService } from "@apps/iloom_customization/design_feed/services/DesignFeedService";
    import { ProductQuery } from "@apps/iloom_customization/modules/products/queries/ProductQuery";
    import { ProductService } from "@apps/iloom_customization/modules/products/services/ProductService";
    import WishlistMediaList from "@apps/iloom_customization/wishlist/components/WishlistMediaList.svelte";
    import WishlistPageTabs from "@apps/iloom_customization/wishlist/components/WishlistPageTabs.svelte";
    import WishlistProductList from "@apps/iloom_customization/wishlist/components/WishlistProductList.svelte";
    import { WishlistedProductsQuery } from "@apps/iloom_customization/wishlist/queries/WishlistedProductsQuery";
    import { WishlistService } from "@apps/iloom_customization/wishlist/services/WishlistService";
    import { WishlistProductStatusesQuery } from "@apps/wishlist/queries/WishlistProductStatusesQuery";
    import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
    import { CartQuery } from "@modules/cart/queries/CartQuery";
    import { CartService } from "@modules/cart/services/CartService";
    import { onMount } from "svelte";
    import { container } from "tsyringe";

    import Portal from "@components/Portal/Portal.svelte";
    import TabsManager from "@components/Tabs/TabsManager";

    export let cartQuery: CartQuery;
    export let cartService: CartService;
    export let designFeedService: DesignFeedService;
    export let mediaListQuery: MediaListQuery;
    export let productQuery: ProductQuery;
    export let productService: ProductService;
    export let tabsManager: TabsManager;
    export let wishlistedProductsQuery: WishlistedProductsQuery;
    export let wishlistService: WishlistService;
    export let wishlistsService: WishlistsService;
    export let wishlistProductStatusesQuery: WishlistProductStatusesQuery;

    const openedTab$ = tabsManager.openedTab$;

    const modalManager = container.resolve(modalManagerToken);

    onMount(() => {
        tabsManager.openTab("products");
    });
</script>

<Page>
    <PageTitle class="gw-cwl-page-title">愿望清单</PageTitle>
    <WishlistPageTabs {tabsManager} />
    {#if $openedTab$ === "products"}
        <WishlistProductList
            {productQuery}
            {wishlistedProductsQuery}
            {wishlistService}
        />
    {:else if $openedTab$ === "media"}
        <WishlistMediaList
            {designFeedService}
            {mediaListQuery}
            {modalManager}
        />
    {/if}
</Page>

<Portal
    Component={DesignFeedModal}
    componentProps={{
        cartQuery,
        cartService,
        designFeedService,
        mediaListQuery,
        modalManager,
        productQuery,
        productService,
        wishlistService,
        wishlistsService,
        wishlistProductStatusesQuery,
    }}
    selector="body"
/>

<style lang="postcss">
    :global(.gw-page-title.gw-cwl-page-title) {
        margin-bottom: 50px;
        @media (max-width: 600px) {
            margin-bottom: 20px;
        }
    }
</style>
